(ns common.schema.entities.integration.nylas-providers)

(def MICROSOFT :nylas.provider/microsoft)
(def GOOGLE :nylas.provider/google)

(def labels
  {MICROSOFT "Microsoft"
   GOOGLE    "Google"})

(def options
  (->> labels
       (map (fn [[k l]]
              {:value k
               :label l}))))

(defn provider->nylas-label
  [provider]
  (get labels provider))
